/** @jsx jsx */
import React from "react"
import { jsx } from "@emotion/core"
import { Link as GatsbyLink } from "gatsby"

export const Link = props => {
  const { to: href, title, children, ...restProps } = props
  const internal = /^\/(?!\/)/.test(href) // https://www.gatsbyjs.org/docs/gatsby-link/#reminder-use-link-only-for-internal-links
  return internal ? (
    <GatsbyLink
      to={href}
      title={title}
      // activeStyle={withTrimMarkMotif}
      activeClassName={"active-link"}
      {...restProps}
    >
      {children}
    </GatsbyLink>
  ) : (
    <a
      href={href}
      title={title}
      // css={linkStyles}
      {...restProps}
    >
      {children}
    </a>
  )
}
